import {useTranslation} from 'react-i18next';
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {agylePref} from '../../store/reducers/preferences';
import ColumnsManager, {getColumns} from './hl7/columns_manager';
import Hl7Messages, {ColumnTypes} from './hl7/hl7_messages_comp';
import Formatter from '../../util/formatter';
import Hl7utils from './hl7/hl7utils';
import {copyToClipboard} from './hl7/hl7_console';
import useOpenState from '../../hooks/useOpenState';
import Hl7ViewJson from './hl7/hl7_view_json';
import _ from 'lodash';
import FHIRMessagesTable from './fhir_messages_table';
import {setSnackbar} from '../../store/reducers/globals';
import FHIRViewJson from './fhir_view_json';

function FHIROutMessages(props){
    const {t} = useTranslation();
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);
    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([]);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const dispatch = useDispatch();
    useEffect(()=>{
        setColumns(getColumns(columnsInit, agylePreference?.fhirMessageColumnOrder));
    },[agylePreference]);

    const openJsonModal = (row) => {
        if(row.fhir) {
            setSelectedRow(row)
            openModal();
        } else {

        }
    }

    const copyJson = (row) => {
        copyToClipboard(JSON.stringify(row.fhir,null,2));
        dispatch(setSnackbar({type: "info", message: t("Message has been copied!")}));
    }

    const columnsInit = [
        {
            name: 'action',
            order: 1,
            value: 'action',
            type: ColumnTypes.CHEACKBOX,
            description: 'Info',
            minWidth: 30
        },
        {
            name: 'dateTime',
            order: 1,
            value: 'date',
            type: ColumnTypes.TEXT,
            description: 'Date',
            minWidth: 10,
            maxWidth: 175,
            sort: true,
            defaultSort: true,
            format: (value,props) => {
                return Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", "");
            }},
        {
            name: 'messageType',
            order: 1,
            value: 'collection',
            type: ColumnTypes.TEXT,
            description: 'Type',
            sort: true,
            minWidth: 10,
            dict: {theatreSessions:"Schedule",operations:"Appointment"},
            format: (value,column) => {
                return column.dict[value];
            },
        },
        {
            name: 'hospitalNumber',
            order: 1,
            value: 'hospitalNumber',
            type: ColumnTypes.TEXT,
            description: 'Hospital number',
            sort: true,
            minWidth: 10 },
        {
            name: 'status',
            order: 1,
            value: 'status',
            type: ColumnTypes.TEXT,
            description: 'Status',
            sort: true,
            minWidth: 10 },
        {
            name: 'actions',
            order: 1,
            value: 'actions',
            type: ColumnTypes.ACTIONS,
            actionList: [
                {   callback: openJsonModal,
                    buttonLabel: "Show JSON"
                },
                {   callback: copyJson,
                    buttonLabel: "Copy JSON"
                }
            ],
            description: 'Actions',
            minWidth: 10 },

    ];

    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };

    const [openConfig, setOpenConfig] = React.useState(false);
    return (<div>
        <ColumnsManager prefPath={"inMessageColumnOrder"}
                        columns = {columns}
                        title={"FHIR Messages Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <FHIRMessagesTable openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"db_fhir_incoming_messages"} columns={sortColumn()} {...props}/>

        {selectedRow && <FHIRViewJson isOpen = {isModalOpen} handleCloseModal = {closeModal} message = {selectedRow.fhir}/>}

    </div>);
}

export default FHIROutMessages;